import { DateSelection } from '@withjoy/joykit';

export const combineDateAndTime = (date: DateSelection, time: string): DateSelection => {
  if (!date) {
    return null;
  }

  if (time === '') {
    return date;
  }

  const [timePart, period] = time.split(' '); // ['02:30', 'PM']
  const [hours, minutes] = timePart.split(':').map(Number);

  let hour24 = hours;

  if (period === 'AM' && hours === 12) {
    hour24 = 0;
  } else if (period === 'PM' && hours !== 12) {
    hour24 = hours + 12;
  }

  const combinedDate = new Date(date);
  combinedDate.setHours(hour24);
  combinedDate.setMinutes(minutes);
  combinedDate.setSeconds(0);

  return combinedDate;
};
